import axios from 'axios';

/** Pulls a readable message out of a backend error. Falls back to a generic one. */
export function getApiErrorMessage(err: unknown, fallback = 'Something went wrong'): string {
  if (axios.isAxiosError(err)) {
    const body = err.response?.data as
      | { message?: string; data?: unknown; detail?: string }
      | undefined;

    if (body?.message) {
      // Field errors, if the backend sends them as { field: ["msg"] } in `data`
      if (body.data && typeof body.data === 'object') {
        const parts = Object.entries(body.data as Record<string, unknown>)
          .map(([field, v]) => {
            const text = Array.isArray(v) ? String(v[0]) : typeof v === 'string' ? v : '';
            return text ? `${field.replace(/_/g, ' ')}: ${text}` : '';
          })
          .filter(Boolean);
        if (parts.length > 0) return `${body.message} (${parts.join('; ')})`;
      }
      return body.message;
    }
    if (body?.detail) return body.detail;
    // No JSON body (e.g. an HTML 500 page): at least say what failed
    if (err.response) return `${fallback} (server returned ${err.response.status})`;
  }
  return fallback;
}
